module.exports = __webpack_public_path__ + "static/media/1008239.34658e4b.png";